<template>
  <iInput
    :type="'textarea'"
    :value="value"
    :rows="rows"
    :autosize="autosize"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :class="$style.textarea"
    @input="$emit('input', $event)"
    @on-input-change="$emit('change', $event)"
    @on-focus="$emit('focus', $event)"
    @on-blur="$emit('blur', $event)"
  />
</template>

<script>
export default {
  name: 'GdlTextarea',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    rows: { type: Number, default: undefined },
    autosize: { type: [Boolean, Object], default: false },
  },
};
</script>

<style lang="scss" module>
.textarea {
  textarea[readonly] {
    border-color: #dddee1;
    box-shadow: unset;
    cursor: auto;

    &::placeholder {
      color: transparent;
    }
  }
}
</style>
